import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useGET from "../../services/useGET.js";

export default function AdminSidebar() {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [visitorCount, setVisitorCount] = useState(0);
    const [userCount, setUserCount] = useState(0);
    const isLocalAdmin = localStorage.getItem("role") === 'LOCALADMIN';

    // Visitor counter
    const { data: visitData } = useGET(
        `${process.env.REACT_APP_API_URL}/api/visits/count`
    );

    useEffect(() => {
        if (visitData) {
            setVisitorCount(visitData.count);
        }
    }, [visitData]);

    // Number of accounts counter
    const { data: userData } = useGET(
        `${process.env.REACT_APP_API_URL}/api/users/count`
    );

    useEffect(() => {
        if (userData) {
            setUserCount(userData.count);
        }
    }, [userData]);

    const isActive = (path) => {
        return location.pathname === path;
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <>
            {/* Mobile Menu Button */}
            <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden fixed top-4 left-4 z-50 bg-charcoal text-white p-3 rounded-lg shadow-lg hover:bg-gray-800 transition-colors"
                aria-label="Toggle menu"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {isMobileMenuOpen ? (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    ) : (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    )}
                </svg>
            </button>

            {/* Overlay for mobile */}
            {isMobileMenuOpen && (
                <div
                    className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                    onClick={closeMobileMenu}
                />
            )}

            {/* Sidebar */}
            <div className={`fixed left-0 top-0 h-screen w-64 bg-charcoal text-white flex flex-col shadow-xl z-40 transition-transform duration-300 ease-in-out ${
                isMobileMenuOpen ? 'translate-x-0' : 'max-md:-translate-x-full'
            }`}>
                {/* Header */}
                <div className="p-6 border-b border-gray-700 flex justify-center md:justify-start">
                    <Link 
                        to="/admin" 
                        onClick={closeMobileMenu}
                        className="hover:opacity-80 transition-opacity"
                    >
                        <h1 className="font-heading text-3xl font-bold">
                            ADMIN
                        </h1>
                    </Link>
                </div>

                {/* Navigation Links */}
                <nav className="flex-grow py-6">
                    <div className="px-6 mb-4">
                        <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">
                            Redigera
                        </h2>
                    </div>

                    <ul className="space-y-2 px-3">
                        <li>
                            <Link
                                to="/admin"
                                onClick={closeMobileMenu}
                                className={`flex items-center px-3 py-3 rounded-lg transition-colors duration-200 ${
                                    isActive('/admin')
                                        ? 'bg-sage text-charcoal'
                                        : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                                }`}
                            >
                                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                <span className="font-medium">Hem</span>
                            </Link>
                        </li>

                        {/* Only ADMIN can see these */} 
                        {!isLocalAdmin && (
                            <> {/* Artlista */} 
                            <li> 
                                <Link 
                                    to="/admin-arter" 
                                    onClick={closeMobileMenu} 
                                    className={`flex items-center px-3 py-3 rounded-lg transition-colors duration-200 ${ 
                                        isActive('/admin-arter') 
                                        ? 'bg-sage text-charcoal' 
                                        : 'text-gray-300 hover:bg-gray-800 hover:text-white' 
                                    }`} 
                                > 
                                    
                                    <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /> 
                                    </svg> 
                                    <span className="font-medium">Artlista</span> 
                                </Link> 
                            
                            </li> 
                            {/* Quiz */} 
                            <li> 
                                <Link 
                                    to="/admin-quiz" 
                                    onClick={closeMobileMenu} 
                                    className={`flex items-center px-3 py-3 rounded-lg transition-colors duration-200 ${ 
                                        isActive('/admin-quiz') 
                                        ? 'bg-sage text-charcoal' 
                                        : 'text-gray-300 hover:bg-gray-800 hover:text-white' 
                                    }`} 
                                > 
                                
                                    <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0z" /> 
                                    </svg> 
                                    <span className="font-medium">Quiz</span> 
                                </Link> 
                            </li> 
                            {/* Quiz inställningar */} 
                            <li> 
                                <Link 
                                    to="/admin-quiz-settings" 
                                    onClick={closeMobileMenu} 
                                    className={`flex items-center px-3 py-3 rounded-lg transition-colors duration-200 ${ 
                                        isActive('/admin-quiz-settings') 
                                        ? 'bg-sage text-charcoal' 
                                        : 'text-gray-300 hover:bg-gray-800 hover:text-white' 
                                    }`} 
                                > 
                                
                                    <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0z" /> 
                                    </svg> 
                                <span className="font-medium">Quiz-inställningar</span> 
                                </Link> 
                            </li>
                            {/* Användar inställningar */} 
                            <li> 
                                <Link 
                                    to="/admin-user-settings" 
                                    onClick={closeMobileMenu} 
                                    className={`flex items-center px-3 py-3 rounded-lg transition-colors duration-200 ${ 
                                        isActive('/admin-quiz-settings') 
                                        ? 'bg-sage text-charcoal' 
                                        : 'text-gray-300 hover:bg-gray-800 hover:text-white' 
                                    }`} 
                                > 
                                
                                    <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0z" /> 
                                    </svg> 
                                <span className="font-medium">Användar-inställningar</span> 
                                </Link> 
                            </li> 
                            </>  
                        )}

                        <li>
                            <Link
                                to="/admin-omraden"
                                onClick={closeMobileMenu}
                                className={`flex items-center px-3 py-3 rounded-lg transition-colors duration-200 ${
                                    isActive('/admin-omraden')
                                        ? 'bg-sage text-charcoal'
                                        : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                                }`}
                            >
                                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                                </svg>
                                <span className="font-medium">Område</span>
                            </Link>
                        </li>
                    </ul>
                </nav>

                {/* Footer */}
                <div className="p-6 border-t border-gray-700">
                    {/* Counters */}
                    <div className="text-sm text-gray-300 text-center space-y-1">
                        <div>
                            👁️ Besök: <span className="font-semibold">{visitorCount}</span>
                        </div>
                        <div>
                            👤 Användare: <span className="font-semibold">{userCount}</span>
                        </div>
                    </div>

                    {/* Back button */}
                    <Link
                        to="/"
                        onClick={closeMobileMenu}
                        className="flex items-center justify-center w-full px-4 py-3 bg-forest hover:bg-leaf text-white font-medium rounded-lg transition-colors duration-200"
                    >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Tillbaka till Användarsidan
                    </Link>
                </div>
            </div>
        </>
    );
}
